import React, { useEffect, useRef } from "react";
import style from "css/workspace.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { useTranslation, Trans } from "react-i18next";
import SEOMeta from "component/app/SEOMeta";

/** 영어 UI에서는 플랫폼 인포 이중 제목의 둘째 줄(i18n)을 숨김 (첫 줄 하드코딩 영문과 중복 방지) */
function isLangEn(lng) {
  return Boolean(lng && String(lng).toLowerCase().startsWith("en"));
}

function Platform(props) {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const showPlatformInfoSecondaryTitle = !isLangEn(i18n.language);
  const phoneDisplay = isLangEn(i18n.language)
    ? "+82-70-7798-1311"
    : "070-7798-1311";
  const phoneHref = "tel:+827077981311";
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });

  const allplaceRef = useRef(null);
  const featureRef = useRef(null);
  const saasRef = useRef(null);
  const onPremiseRef = useRef(null);
  const contactRef = useRef(null);

  const handleClickFloatingBtn = () => {
    saasRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  const sectionRefs = {
    allplace: allplaceRef,
    feature: featureRef,
    saas: saasRef,
    "on-premise": onPremiseRef,
    contact: contactRef,
  };
  const scrollToSection = (link, behavior) => {
    sectionRefs[link]?.current?.scrollIntoView({ behavior, block: "start" });
  };

  //헤더/푸터 메뉴 클릭 — 클릭마다 새 객체라 같은 메뉴를 다시 눌러도 스크롤됨
  useEffect(() => {
    //페이지 이동으로 들어온 경우는 아래 effect 가 처리
    if (location.state?.link) return;
    scrollToSection(props.link?.link, "smooth");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.link]);

  //다른 페이지에서 navigate("/", { state: { link } })로 들어온 경우 — 애니메이션 없이 바로 이동 후 state 비움
  const stateLink = location.state?.link;
  useEffect(() => {
    if (!stateLink) return;
    scrollToSection(stateLink, "instant");
    navigate(location.pathname, { replace: true, state: null });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateLink]);

  return (
    <div className={style.fontsize}>
      <SEOMeta
        title={t("landing.seo.title")}
        description={t("landing.seo.description")}
        keywords={t("landing.seo.keywords")}
      />
      <div
        className={style.wrapper}
        style={
          !isMobile && !isTablet
            ? {
                marginTop: props.isOpenNotice ? "138px" : "90px",
              }
            : {
                marginTop: props.isOpenNotice ? "100px" : "65px",
              }
        }
      >
        <button
          className={style.floating_btn}
          onClick={handleClickFloatingBtn}
          style={
            !isMobile && !isTablet
              ? {
                  top: props.isOpenNotice ? "178px" : "130px",
                }
              : {
                  top: props.isOpenNotice ? "117px" : "82px",
                }
          }
        >
          <div className={style.floating_btn_wrap}>
            <img
              alt=""
              src={`${process.env.REACT_APP_CLIENT_URL}img/common/new.png`}
            />
            <div className={style.floating_btn_text}>
              <span>{t("landing.floatingL1")}</span>
              {"\n"}
              {t("landing.floatingL2")}
            </div>
            <img
              alt=""
              src={`${process.env.REACT_APP_CLIENT_URL}img/common/down.png`}
            />
          </div>
        </button>
        <div className={style.commonHeader}>
          <div className={style.platformHeaderTxt}>
            <p>
              <font>{t("landing.heroL1")}</font>
              <font>{t("landing.heroL2")}</font>
            </p>
            <img
              alt=""
              src={`${process.env.REACT_APP_CLIENT_URL}img/common/allplace_logo_wh.png`}
            />
            <p>
              {!isMobile && !isTablet ? (
                <>
                  <font>{t("landing.heroIntro1")}</font>
                  <font>{t("landing.heroIntro2")}</font>
                </>
              ) : (
                <>
                  <font style={{ whiteSpace: "pre-line" }}>
                    {t("landing.heroIntroM")}
                  </font>
                </>
              )}
            </p>
          </div>
          {!isMobile && !isTablet ? (
            <img
              className={style.platformHeaderImg}
              alt=""
              src={`${process.env.REACT_APP_CLIENT_URL}img/smartspace/platformHeader.png`}
            />
          ) : (
            <div className={style.platformHeaderImgWrap}>
              <img
                className={style.platformHeaderImg}
                alt=""
                src={`${process.env.REACT_APP_CLIENT_URL}img/smartspace/platformHeader_1_m.png`}
              />
              <img
                className={style.platformHeaderImg}
                alt=""
                src={`${process.env.REACT_APP_CLIENT_URL}img/smartspace/platformHeader_2_m.png`}
              />
            </div>
          )}

          <div
            ref={allplaceRef}
            style={{ padding: !isMobile && !isTablet ? "70px 0" : "20px 0" }}
          />

          <div className={style.platformHeader2}>
            <p style={{ whiteSpace: "pre-line" }}>
              {t("landing.subHeroTitle")}
            </p>
            <p style={{ whiteSpace: "pre-line" }}>{t(isMobile ? "landing.subHeroSubM" : "landing.subHeroSub")}</p>
            <div className={style.platformHeader2CardWrap}>
              <div>
                <img
                  alt=""
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/smartspace/platformCardImg.png"
                  }
                />
                <font>
                  {t("landing.cardA1")}
                  <br /> <label>{t("landing.cardA2")}</label>{" "}
                  {t("landing.cardA3")}
                </font>
              </div>
              <div>
                <img
                  alt=""
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/smartspace/platformCardImg2.png"
                  }
                />
                <font>
                  {t("landing.cardB1")}
                  <br /> <label>{t("landing.cardB2")}</label>
                </font>
              </div>
              <div>
                <img
                  alt=""
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/smartspace/platformCardImg3.png"
                  }
                />
                <font>
                  {t("landing.cardC1")}
                  <br /> <label>{t("landing.cardC2")}</label>
                </font>
              </div>
            </div>
          </div>
          <div className={style.platformHeader3}>
            <div className={style.txt}>
              <font>{t("landing.whyL1")}</font>
              <font>{t("landing.whyL2")}</font>
            </div>
            <div className={style.cardWrap}>
              {!isMobile && !isTablet ? (
                <>
                  <div className={style.cardList}>
                    <div className={style.card2}>
                      <div className={style.card1Num}>01</div>
                      <div className={style.card2Txt}>
                        <font className={style.highlight}>
                          {t("landing.rMeetingT")}
                        </font>
                        <font>{t("landing.rMeetingD")}</font>
                      </div>
                    </div>
                    <div className={style.card2}>
                      <div className={style.card1Num}>02</div>
                      <div className={style.card2Txt}>
                        <font className={style.highlight}>
                          {t("landing.rDeskT")}
                        </font>
                        <font>{t("landing.rDeskD")}</font>
                      </div>
                    </div>
                  </div>
                  <div className={style.cardList}>
                    <div className={style.card2}>
                      <div className={style.card1Num}>03</div>
                      <div className={style.card2Txt}>
                        <font className={style.highlight}>
                          {t("landing.rVideoT")}
                        </font>
                        <font>{t("landing.rVideoD")}</font>
                      </div>
                    </div>
                    <div className={style.card2}>
                      <div className={style.card1Num}>04</div>
                      <div className={style.card2Txt}>
                        <font>{t("landing.rDash1")}</font>
                        <font>{t("landing.rDash2")}</font>
                      </div>
                    </div>
                  </div>
                  <div className={style.card1}>
                    <div className={style.card1Line}>
                      <font className={style.card1Num}>05</font>
                      <div className={style.card1Txt}>
                        <Trans
                          i18nKey="landing.rPlatform"
                          components={{ 1: <span /> }}
                        />
                      </div>
                    </div>
                    <div className={style.card1Line}>
                      <font className={style.card1Num2}>01</font>
                      <div className={style.cardImgList}>
                        <img
                          alt=""
                          src={
                            `${process.env.REACT_APP_CLIENT_URL}` +
                            "img/smartspace/platformComp1.png"
                          }
                        />
                        <div />
                        <img
                          alt=""
                          src={
                            `${process.env.REACT_APP_CLIENT_URL}` +
                            "img/smartspace/platformComp2.png"
                          }
                        />
                        <div />
                        <img
                          alt=""
                          src={
                            `${process.env.REACT_APP_CLIENT_URL}` +
                            "img/smartspace/platformComp3.png"
                          }
                        />
                        <div />
                        <img
                          alt=""
                          src={
                            `${process.env.REACT_APP_CLIENT_URL}` +
                            "img/smartspace/platformComp4.png"
                          }
                        />
                        <div />
                        <img
                          alt=""
                          src={
                            `${process.env.REACT_APP_CLIENT_URL}` +
                            "img/smartspace/platformComp5.png"
                          }
                        />
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className={style.card2}>
                    <div className={style.card1Num}>01</div>
                    <div className={style.card2Txt}>
                      <font className={style.highlight}>
                        {t("landing.rMeetingT")}
                      </font>
                      <font>{t("landing.rMeetingD")}</font>
                    </div>
                  </div>
                  <div className={style.card2}>
                    <div className={style.card1Num}>02</div>
                    <div className={style.card2Txt}>
                      <font className={style.highlight}>
                        {t("landing.rDeskT")}
                      </font>
                      <font>{t("landing.rDeskD")}</font>
                    </div>
                  </div>
                  <div className={style.card2}>
                    <div className={style.card1Num}>03</div>
                    <div className={style.card2Txt}>
                      <font className={style.highlight}>
                        {t("landing.rVideoT")}
                      </font>
                      <font>{t("landing.rVideoD")}</font>
                    </div>
                  </div>
                  <div className={style.card2}>
                    <div className={style.card1Num}>04</div>
                    <div className={style.card2Txt}>
                      <font>{t("landing.rDash1")}</font>
                      <font>{t("landing.rDash2")}</font>
                    </div>
                  </div>
                  <div className={style.card1}>
                    <div className={style.card1Line}>
                      <font className={style.card1Num}>05</font>
                      <div className={style.card1Txt}>
                        <Trans
                          i18nKey="landing.rPlatform"
                          components={{ 1: <span /> }}
                        />
                      </div>
                    </div>
                    <div className={style.card1Line}>
                      {/* <font className={style.card1Num2}>01</font> */}
                      <div className={style.cardImgList}>
                        <img
                          alt=""
                          src={
                            `${process.env.REACT_APP_CLIENT_URL}` +
                            "img/smartspace/platformComp1.png"
                          }
                        />
                        <div />
                        <img
                          alt=""
                          src={
                            `${process.env.REACT_APP_CLIENT_URL}` +
                            "img/smartspace/platformComp2.png"
                          }
                        />
                        <div />
                        <img
                          alt=""
                          src={
                            `${process.env.REACT_APP_CLIENT_URL}` +
                            "img/smartspace/platformComp3.png"
                          }
                        />
                      </div>
                      <div className={style.cardImgList}>
                        <img
                          alt=""
                          src={
                            `${process.env.REACT_APP_CLIENT_URL}` +
                            "img/smartspace/platformComp4.png"
                          }
                        />
                        <div />
                        <img
                          alt=""
                          src={
                            `${process.env.REACT_APP_CLIENT_URL}` +
                            "img/smartspace/platformComp5.png"
                          }
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        <div
          ref={featureRef}
          style={{ padding: !isMobile && !isTablet ? "10px 0" : "20px 0" }}
        />
        <div className={style.platformHeader4}>
          <font
          // style={{ whiteSpace: "pre-line" }}
          >
            {t("landing.allInOneTitle")}
          </font>
          <font style={{ whiteSpace: "pre-line" }}>
            {t("landing.allInOneBody")}
          </font>
          {!isTablet && !isMobile ? (
            <div className={style.imgBorderWrap}>
              <img
                alt=""
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  "img/smartspace/platformSolution.png"
                }
              />
            </div>
          ) : (
            <img
              alt=""
              src={
                `${process.env.REACT_APP_CLIENT_URL}` +
                "img/smartspace/platformSolution_m.png"
              }
            />
          )}
        </div>

        <div className={style.platformInfo}>
          <div className={style.InfoHeader}>
            <font style={{ whiteSpace: "pre-line" }}>
              {t("landing.infoHeadTitle")}
            </font>
            <font style={{ whiteSpace: "pre-line" }}>
              {t(isMobile ? "landing.infoHeadBodyM" : "landing.infoHeadBody")}
            </font>
          </div>

          <div className={style.platformWrap}>
            <div className={style.infoTxt}>
              <div className={style.infoTxtImg}>
                <img
                  alt=""
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/smartspace/infotxt1.png"
                  }
                />
              </div>
              <p className={style.infoTxtTitle}>
                <font>Main Page</font>
                {showPlatformInfoSecondaryTitle && (
                  <>
                    <span /> <font>{t("landing.mainKo")}</font>
                  </>
                )}
              </p>
              <p className={style.infoTxtBody}>
                <font>
                  <label style={{ whiteSpace: "pre-line" }}>
                    {t("landing.mainLead")}
                  </label>
                  <br />
                  <span style={{ whiteSpace: "pre-line" }}>
                    {!isMobile && !isTablet
                      ? t("landing.mainBodyD")
                      : t("landing.mainBodyM")}
                  </span>
                </font>
              </p>
            </div>
            <div className={style.infoImg}>
              <img
                alt=""
                src={
                  !isMobile && !isTablet
                    ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg1.png`
                    : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg1_m.png`
                }
              />
            </div>
          </div>

          {!isMobile && !isTablet ? (
            <div className={style.platformWrap}>
              <div className={style.infoImg}>
                <img
                  alt=""
                  src={
                    !isMobile && !isTablet
                      ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg2.png`
                      : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg2_m.png`
                  }
                />
              </div>
              <div className={style.infoTxt2}>
                <div className={style.infoTxtImg}>
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/infotxt2.png"
                    }
                  />
                </div>
                <p className={style.infoTxtTitle}>
                  <font>
                    Hot Desking
                    <br />
                    Reservation & Status
                  </font>{" "}
                  {showPlatformInfoSecondaryTitle && (
                    <font>{t("landing.hdKo")}</font>
                  )}
                </p>
                <p className={style.infoTxtBody}>
                  <font>
                    {t("landing.hdBodyD1")}
                    <label>{t("landing.hdBodyD2")}</label>
                    {t("landing.hdBodyD3")}
                    <br />
                    <label>{t("landing.hdBodyD4")}</label>
                    {t("landing.hdBodyD5")}
                  </font>
                </p>
              </div>
            </div>
          ) : (
            <div className={style.platformWrap}>
              <div className={style.infoTxt2}>
                <div className={style.infoTxtImg}>
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/infotxt2.png"
                    }
                  />
                </div>
                <p className={style.infoTxtTitle}>
                  <font>
                    Hot Desking
                    <br />
                    Reservation & Status
                  </font>{" "}
                  {showPlatformInfoSecondaryTitle && (
                    <font>{t("landing.hdKo")}</font>
                  )}
                </p>
                <p className={style.infoTxtBody}>
                  <font style={{ whiteSpace: "pre-line" }}>
                    {t("landing.hdBodyMob")}
                  </font>
                </p>
              </div>
              <div className={style.infoImg}>
                <img
                  alt=""
                  src={
                    !isMobile && !isTablet
                      ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg2.png`
                      : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg2_m.png`
                  }
                />
              </div>
            </div>
          )}

          <div className={style.platformWrap}>
            <div className={style.infoTxt}>
              <div className={style.infoTxtImg}>
                <img
                  alt=""
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/smartspace/infotxt3.png"
                  }
                />
              </div>
              <p className={style.infoTxtTitle}>
                <font>{t("landing.birdTitle")}</font>
              </p>
              <p className={style.infoTxtBody}>
                <font style={{ whiteSpace: "pre-line" }}>
                  {t("landing.birdD")}
                  {"\n\n"}
                  {t("landing.birdFoot")}
                </font>
              </p>
            </div>
            <div className={style.infoImg}>
              <img
                alt=""
                src={
                  !isMobile && !isTablet
                    ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg3.png`
                    : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg3_m.png`
                }
              />
            </div>
          </div>

          {!isMobile && !isTablet ? (
            <div className={style.platformWrap}>
              <div className={style.infoImg}>
                <img
                  alt=""
                  src={
                    !isMobile && !isTablet
                      ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg4.png`
                      : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg4_m.png`
                  }
                />
              </div>
              <div className={style.infoTxt2}>
                <div className={style.infoTxtImg}>
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/infotxt4.png"
                    }
                  />
                </div>
                <p className={style.infoTxtTitle}>
                  <font>Hot Desking Colleague Status</font>
                  {showPlatformInfoSecondaryTitle && (
                    <font>{t("landing.colKo")}</font>
                  )}
                </p>
                <p className={style.infoTxtBody}>
                  <font style={{ whiteSpace: "pre-line" }}>
                    <Trans
                      i18nKey="landing.colBodyDesk"
                      components={{
                        1: <label />,
                        2: <label />,
                        3: <label />,
                      }}
                    />
                  </font>
                </p>
              </div>
            </div>
          ) : (
            <div className={style.platformWrap}>
              <div className={style.infoTxt2}>
                <div className={style.infoTxtImg}>
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/infotxt4.png"
                    }
                  />
                </div>
                <p className={style.infoTxtTitle}>
                  <font>Hot Desking Colleague Status</font>
                  {showPlatformInfoSecondaryTitle && (
                    <font>{t("landing.colKo")}</font>
                  )}
                </p>
                <p className={style.infoTxtBody}>
                  <font style={{ whiteSpace: "pre-line" }}>
                    <Trans
                      i18nKey="landing.colBodyMob"
                      components={{
                        1: <label />,
                        2: <label />,
                        3: <label />,
                      }}
                    />
                  </font>
                </p>
              </div>
              <div className={style.infoImg}>
                <img
                  alt=""
                  src={
                    !isMobile && !isTablet
                      ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg4.png`
                      : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg4_m.png`
                  }
                />
              </div>
            </div>
          )}

          {!isMobile && !isTablet ? (
            <div className={style.platformWrap}>
              <div className={style.infoTxt}>
                <div className={style.infoTxtImg}>
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/infotxt5.png"
                    }
                  />
                </div>
                <p className={style.infoTxtTitle}>
                  <font>Meeting Room Overview</font>{" "}
                  {showPlatformInfoSecondaryTitle && (
                    <font>{t("landing.meetKo")}</font>
                  )}
                </p>
                <p className={style.infoTxtBody}>
                  <font style={{ whiteSpace: "pre-line" }}>
                    {t("landing.meetD")}
                  </font>
                </p>
              </div>
              <div className={style.infoImg}>
                <img
                  alt=""
                  src={
                    !isMobile && !isTablet
                      ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg5.png`
                      : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg5_m.png`
                  }
                />
              </div>
            </div>
          ) : (
            <div className={style.platformWrap}>
              <div className={style.infoTxt2}>
                <div className={style.infoTxtImg}>
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/infotxt5.png"
                    }
                  />
                </div>
                <p className={style.infoTxtTitle}>
                  <font>Meeting Room Overview</font>{" "}
                  {showPlatformInfoSecondaryTitle && (
                    <font>{t("landing.meetKo")}</font>
                  )}
                </p>
                <p className={style.infoTxtBody}>
                  <font style={{ whiteSpace: "pre-line" }}>
                    {t("landing.meetD")}
                  </font>
                </p>
              </div>
              <div className={style.infoImg}>
                <img
                  alt=""
                  src={
                    !isMobile && !isTablet
                      ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg5.png`
                      : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg5_m.png`
                  }
                />
              </div>
            </div>
          )}

          {!isMobile && !isTablet ? (
            <div className={style.platformWrap}>
              <div className={style.infoImg}>
                <img
                  alt=""
                  src={
                    !isMobile && !isTablet
                      ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg9.png`
                      : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg9_m.png`
                  }
                />
              </div>
              <div className={style.infoTxt2}>
                <div className={style.infoTxtImg}>
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/infotxt9.png"
                    }
                  />
                </div>
                <p className={style.infoTxtTitle}>
                  <font>Check-in & Wall Pad (neat.pad)</font>
                  {showPlatformInfoSecondaryTitle && (
                    <font>{t("landing.wallKo")}</font>
                  )}
                </p>
                <p className={style.infoTxtBody}>
                  <font style={{ whiteSpace: "pre-line" }}>
                    <Trans
                      i18nKey="landing.wallBody"
                      components={{ 1: <label /> }}
                    />
                  </font>
                </p>
              </div>
            </div>
          ) : (
            <div className={style.platformWrap}>
              <div className={style.infoTxt2}>
                <div className={style.infoTxtImg}>
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/infotxt9.png"
                    }
                  />
                </div>
                <p className={style.infoTxtTitle}>
                  <font>Check-in & Wall Pad (neat.pad)</font>
                  {showPlatformInfoSecondaryTitle && (
                    <font>{t("landing.wallKo")}</font>
                  )}
                </p>
                <p className={style.infoTxtBody}>
                  <font style={{ whiteSpace: "pre-line" }}>
                    <Trans
                      i18nKey="landing.wallBody"
                      components={{ 1: <label /> }}
                    />
                  </font>
                </p>
              </div>
              <div className={style.infoImg}>
                <img
                  alt=""
                  src={
                    !isMobile && !isTablet
                      ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg9.png`
                      : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg9_m.png`
                  }
                />
              </div>
            </div>
          )}

          {!isMobile && !isTablet ? (
            <div className={style.platformWrap}>
              <div className={style.infoTxt}>
                <div className={style.infoTxtImg}>
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/infotxt6.png"
                    }
                  />
                </div>
                <p className={style.infoTxtTitle}>
                  <font>Calendar</font>
                  {showPlatformInfoSecondaryTitle && (
                    <font>{t("landing.calKo")}</font>
                  )}
                </p>
                <p className={style.infoTxtBody}>
                  <font style={{ whiteSpace: "pre-line" }}>
                    {t("landing.calD")}
                  </font>
                </p>
              </div>
              <div className={style.infoImg}>
                <img
                  alt=""
                  src={
                    !isMobile && !isTablet
                      ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg6.png`
                      : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg6_m.png`
                  }
                />
              </div>
            </div>
          ) : (
            <div className={style.platformWrap}>
              <div className={style.infoTxt2}>
                <div className={style.infoTxtImg}>
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/infotxt6.png"
                    }
                  />
                </div>
                <p className={style.infoTxtTitle}>
                  <font>Calendar</font>
                  {showPlatformInfoSecondaryTitle && (
                    <font>{t("landing.calKo")}</font>
                  )}
                </p>
                <p className={style.infoTxtBody}>
                  <font style={{ whiteSpace: "pre-line" }}>
                    {t("landing.calD")}
                  </font>
                </p>
              </div>
              <div className={style.infoImg}>
                <img
                  alt=""
                  src={
                    !isMobile && !isTablet
                      ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg6.png`
                      : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg6_m.png`
                  }
                />
              </div>
            </div>
          )}

          {!isMobile && !isTablet ? (
            <div className={style.platformWrap}>
              <div className={style.infoImg}>
                <img
                  alt=""
                  src={`${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg7_m.png`}
                />
              </div>
              <div className={style.infoTxt2}>
                <div className={style.infoTxtImg}>
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/infotxt7.png"
                    }
                  />
                </div>
                <p className={style.infoTxtTitle}>
                  <font>Multi-Platform</font>{" "}
                  {showPlatformInfoSecondaryTitle && (
                    <font>{t("landing.multiKo")}</font>
                  )}
                </p>
                <p className={style.infoTxtBody}>
                  <font style={{ whiteSpace: "pre-line" }}>
                    {t("landing.multiD")}
                  </font>
                </p>
              </div>
            </div>
          ) : (
            <div className={style.platformWrap}>
              <div className={style.infoTxt2}>
                <div className={style.infoTxtImg}>
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/infotxt7.png"
                    }
                  />
                </div>
                <p className={style.infoTxtTitle}>
                  <font>Multi-Platform</font>{" "}
                  {showPlatformInfoSecondaryTitle && (
                    <font>{t("landing.multiKo")}</font>
                  )}
                </p>
                <p className={style.infoTxtBody}>
                  <font style={{ whiteSpace: "pre-line" }}>
                    {t("landing.multiD")}
                  </font>
                </p>
              </div>
              <div className={style.infoImg}>
                <img
                  alt=""
                  src={`${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg7_m.png`}
                />
              </div>
            </div>
          )}

          {!isMobile && !isTablet ? (
            <div className={style.platformWrap}>
              <div className={style.infoTxt}>
                <div className={style.infoTxtImg}>
                  <img
                    alt=""
                    src={`${process.env.REACT_APP_CLIENT_URL}img/smartspace/infotxt8.png`}
                  />
                </div>
                <p className={style.infoTxtTitle}>
                  <font>Dashboard</font>
                  {showPlatformInfoSecondaryTitle && (
                    <font>{t("landing.dashKo")}</font>
                  )}
                </p>
                <p className={style.infoTxtBody}>
                  <font style={{ whiteSpace: "pre-line" }}>
                    {t("landing.dashD")}
                  </font>
                </p>
              </div>
              <div className={style.infoImg}>
                <img
                  alt=""
                  src={
                    !isMobile && !isTablet
                      ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg8.png`
                      : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg8_m.png`
                  }
                />
              </div>
            </div>
          ) : (
            <div className={style.platformWrap}>
              <div className={style.infoTxt2}>
                <div className={style.infoTxtImg}>
                  <img
                    alt=""
                    src={`${process.env.REACT_APP_CLIENT_URL}img/smartspace/infotxt8.png`}
                  />
                </div>
                <p className={style.infoTxtTitle}>
                  <font>Dashboard</font>
                  {showPlatformInfoSecondaryTitle && (
                    <font>{t("landing.dashKo")}</font>
                  )}
                </p>
                <p className={style.infoTxtBody}>
                  <font style={{ whiteSpace: "pre-line" }}>
                    {t("landing.dashD")}
                  </font>
                </p>
              </div>
              <div className={style.infoImg}>
                <img
                  alt=""
                  src={
                    !isMobile && !isTablet
                      ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg8.png`
                      : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg8_m.png`
                  }
                />
              </div>
            </div>
          )}

          <div
            ref={saasRef}
            style={{ padding: !isMobile && !isTablet ? "5px 0" : null }}
          />
          <div
            className={style.introduction_method_area}
            // ref={saasRef}
          >
            <div className={style.introduction_method_title_wrap}>
              <div className={style.introduction_method_label}>
                {t("landing.priceLabel")}
              </div>
              <div
                className={style.introduction_method_title}
                style={{ whiteSpace: "pre-line" }}
              >
                {t("landing.priceTitle0")}{" "}
                <span>{t("landing.priceTitle1")}</span>
                {t("landing.priceTitleMid")}{" "}
                <span>{t("landing.priceTitle2")}</span>{" "}
                {t("landing.priceTitle3")}{" "}
                <span>{t("landing.priceTitle4")}</span>{" "}
                {t("landing.priceTitle5")}
              </div>
            </div>
            <div className={style.introduction_method_contents}>
              <div className={style.introduction_method_box}>
                <div className={style.introduction_method_item_title}>
                  Standard
                </div>
                <div className={style.introduction_system_wrapper}>
                  <div className={style.introduction_system_box}>
                    <div className={style.introduction_system_box_header}>
                      <div className={style.introduction_system_box_title_wrap}>
                        <img
                          alt=""
                          src={`${process.env.REACT_APP_CLIENT_URL}img/common/allplace_logo_wh.png`}
                        />
                        <div className={style.introduction_system_box_title}>
                          {t("landing.stdMeeting")}
                        </div>
                      </div>
                      <div
                        className={style.introduction_system_box_description}
                      >
                        {t("landing.stdMeetingDesc")}
                      </div>
                    </div>
                    <div className={style.introduction_system_box_body}>
                      <div className={style.introduction_system_price}>
                        <div className={style.introduction_system_price_value}>
                          {t("landing.won25000")}
                        </div>
                        <div className={style.introduction_system_price_label}>
                          {t("landing.perRoomMonth")}
                        </div>
                      </div>
                      <div className={style.introduction_system_built_in}>
                        {t("landing.stdBuilt1")}
                      </div>
                    </div>
                    <div className={style.introduction_system_option_list}>
                      <div
                        className={style.introduction_system_option_item}
                        style={{ whiteSpace: "pre-line" }}
                      >
                        <span
                          className={style.introduction_system_option_item_spot}
                        />
                        <span>{t("landing.optPrefix")}</span>
                        {t("landing.optWallPad")}
                      </div>
                      <div
                        className={style.introduction_system_option_item}
                        style={{ whiteSpace: "pre-line" }}
                      >
                        <span
                          className={style.introduction_system_option_item_spot}
                        />
                        <span>{t("landing.discPrefix")}</span>
                        {t("landing.discountPolicy")}
                      </div>
                    </div>
                  </div>
                  <div className={style.introduction_system_box}>
                    <div className={style.introduction_system_box_header}>
                      <div className={style.introduction_system_box_title_wrap}>
                        <img
                          alt=""
                          src={`${process.env.REACT_APP_CLIENT_URL}img/common/allplace_logo_wh.png`}
                        />
                        <div className={style.introduction_system_box_title}>
                          {t("landing.stdDesk")}
                        </div>
                      </div>
                      <div
                        className={style.introduction_system_box_description}
                      >
                        {t("landing.stdDeskDesc")}
                      </div>
                    </div>
                    <div className={style.introduction_system_box_body}>
                      <div className={style.introduction_system_price}>
                        <div className={style.introduction_system_price_value}>
                          {t("landing.won2000")}
                        </div>
                        <div className={style.introduction_system_price_label}>
                          {t("landing.perSeatMonth")}
                        </div>
                      </div>
                      <div className={style.introduction_system_built_in}>
                        {t("landing.stdBuilt2")}
                      </div>
                    </div>
                    <div className={style.introduction_system_option_list}>
                      <div className={style.introduction_system_option_item}>
                        <span
                          className={style.introduction_system_option_item_spot}
                        />
                        <span>{t("landing.optPrefix")}</span>
                        {t("landing.optNameplate")}
                      </div>
                      <div className={style.introduction_system_option_item}>
                        <span
                          className={style.introduction_system_option_item_spot}
                        />
                        <span>{t("landing.discPrefix")}</span>
                        {t("landing.discountPolicy")}
                      </div>
                    </div>
                  </div>
                </div>
                <div className={style.introduction_system_feature}>
                  <div className={style.introduction_system_feature_label}>
                    {t("landing.coreLabel")}
                  </div>
                  <div className={style.introduction_system_feature_list}>
                    <div className={style.introduction_system_feature_item}>
                      {t("landing.f1")}
                    </div>
                    <div className={style.introduction_system_feature_item}>
                      {t("landing.f2")}
                    </div>
                    <div className={style.introduction_system_feature_item}>
                      {t("landing.f3")}
                    </div>
                    <div className={style.introduction_system_feature_item}>
                      {t("landing.f4")}
                    </div>
                    <div className={style.introduction_system_feature_item}>
                      {t("landing.f5")}
                    </div>
                    <div className={style.introduction_system_feature_item}>
                      {t("landing.f7")}
                    </div>
                    <div className={style.introduction_system_feature_item}>
                      {t("landing.f8")}
                    </div>
                    <div className={style.introduction_system_feature_item}>
                      {t("landing.f6")}
                    </div>
                  </div>
                </div>
              </div>
              <div className={style.introduction_method_box}>
                <div className={style.introduction_method_item_title}>
                  Enterprise
                </div>
                <div className={style.introduction_enterprise_price}>
                  <div className={style.introduction_enterprise_price_label}>
                    {t("landing.entConsult")}
                  </div>
                  <div className={style.introduction_enterprise_feature_box}>
                    <div className={style.introduction_standard_feature}>
                      {t("landing.entStd")}
                    </div>
                    <div
                      className={style.introduction_enterprise_plus_icon_box}
                    >
                      +
                    </div>
                    <div className={style.introduction_enterprise_feature}>
                      <div
                        className={style.introduction_enterprise_feature_label}
                      >
                        {t("landing.entPlus")}
                      </div>
                      <div
                        className={style.introduction_enterprise_feature_list}
                      >
                        <div
                          className={style.introduction_enterprise_feature_item}
                        >
                          {t("landing.e1")}
                        </div>
                        <div
                          className={style.introduction_enterprise_feature_item}
                        >
                          {t("landing.e2")}
                        </div>
                        <div
                          className={style.introduction_enterprise_feature_item}
                        >
                          {t("landing.e3")}
                        </div>
                        <div
                          className={style.introduction_enterprise_feature_item}
                        >
                          {t("landing.e4")}
                        </div>
                        <div
                          className={style.introduction_enterprise_feature_item}
                        >
                          {t("landing.e5")}
                        </div>
                        <div
                          className={style.introduction_enterprise_feature_item}
                        >
                          {t("landing.e6")}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className={style.contact_list}
              style={
                !isMobile && !isTablet
                  ? { marginBottom: "22px" }
                  : { padding: "12px 22px 32px" }
              }
            >
              <div className={style.contact_item}>
                <div className={style.contact_item_title}>
                  {t("landing.subContact")}
                </div>
              </div>
              <div className={style.contact_item}>
                <div className={style.contact_item_icon_wrap}>
                  <img
                    alt=""
                    src={
                      !isMobile && !isTablet
                        ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/tel.png`
                        : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/tel_m.png`
                    }
                  />
                </div>
                <div className={style.contact_item_text}>
                  <a href={phoneHref}>{phoneDisplay}</a>
                </div>
              </div>
              {!isMobile && !isTablet ? <span /> : null}
              <div className={style.contact_item}>
                <div className={style.contact_item_icon_wrap}>
                  <img
                    alt=""
                    src={
                      !isMobile && !isTablet
                        ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/mail.png`
                        : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/mail_m.png`
                    }
                  />
                </div>
                <div className={style.contact_item_text}>
                  support@riv-tech.co.kr
                </div>
              </div>
            </div>

            <div className={style.launching_promotion_box}>
              <div className={style.launching_promotion_title}>
                {t("landing.promoTitle1")}
                <span>{t("landing.promoTitle2")}</span> <strong>X2</strong>
                {t("landing.promoTitle3")}
              </div>
              <div className={style.launching_promotion_benefit_list}>
                <div className={style.launching_promotion_benefit_item}>
                  <div className={style.launching_promotion_benefit_item_box}>
                    <div
                      className={style.launching_promotion_benefit_item_label}
                    >
                      {t("landing.ben1")}
                    </div>
                    <div
                      className={style.launching_promotion_benefit_item_title}
                      style={isMobile ? { textAlign: "center" } : {}}
                    >
                      {isMobile ? (
                        <>
                          {t("landing.ben1T1M")}
                          <br />
                          <span>{t("landing.ben1T2M")}</span>
                        </>
                      ) : (
                        <>
                          {t("landing.ben1T1")}
                          <span>{t("landing.ben1T2")}</span>
                        </>
                      )}
                    </div>
                  </div>
                  <div className={style.launching_promotion_benefit_item_text}>
                    {t("landing.ben1Note")}
                  </div>
                </div>
                <div className={style.launching_promotion_benefit_item}>
                  <div className={style.launching_promotion_benefit_item_box}>
                    <div
                      className={style.launching_promotion_benefit_item_label}
                    >
                      {t("landing.ben2")}
                    </div>
                    <div
                      className={style.launching_promotion_benefit_item_title}
                      style={isMobile ? { textAlign: "center" } : {}}
                    >
                      {isMobile ? (
                        <>
                          {t("landing.ben2T1M")}
                          <br />
                          <span>{t("landing.ben2T2M")}</span>
                        </>
                      ) : (
                        <>
                          {t("landing.ben2T1")}
                          <span>{t("landing.ben2T2")}</span>
                        </>
                      )}
                    </div>
                  </div>
                  <div className={style.launching_promotion_benefit_item_text}>
                    {t("landing.ben2Note")}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            ref={onPremiseRef}
            style={{ padding: !isMobile && !isTablet ? "30px 0" : "40px 0" }}
          />
          <div className={style.introduce_on_premise_area}>
            <div className={style.introduce_on_premise_title_wrap}>
              <div className={style.introduce_on_premise_title}>
                {t("landing.onPremTitle")}
              </div>
              <div
                className={style.introduce_on_premise_text}
                style={{ whiteSpace: "pre-line" }}
              >
                {isMobile || isTablet ? (
                  <Trans
                    i18nKey="landing.onPremLeadM"
                    components={{ 1: <span />, 2: <span /> }}
                  />
                ) : (
                  <Trans
                    i18nKey="landing.onPremLead"
                    components={{ 1: <span />, 2: <span /> }}
                  />
                )}
              </div>
            </div>
            <div className={style.introduce_on_premise_feature_list}>
              <div className={style.introduce_on_premise_feature_item_box}>
                <div className={style.introduce_on_premise_feature_icon_wrap}>
                  <img
                    alt=""
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/allplace/infra.png`}
                  />
                </div>
                <div className={style.introduce_on_premise_feature_contents}>
                  <div className={style.introduce_on_premise_feature_label}>
                    {t("landing.opF1T")}
                  </div>
                  <div className={style.introduce_on_premise_feature_text}>
                    {t("landing.opF1D")}
                  </div>
                </div>
              </div>
              <div className={style.introduce_on_premise_feature_item_box}>
                <div className={style.introduce_on_premise_feature_icon_wrap}>
                  <img
                    alt=""
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/allplace/design.png`}
                  />
                </div>
                <div className={style.introduce_on_premise_feature_contents}>
                  <div className={style.introduce_on_premise_feature_label}>
                    {t("landing.opF2T")}
                  </div>
                  <div className={style.introduce_on_premise_feature_text}>
                    {t("landing.opF2D")}
                  </div>
                </div>
              </div>
              <div className={style.introduce_on_premise_feature_item_box}>
                <div className={style.introduce_on_premise_feature_icon_wrap}>
                  <img
                    alt=""
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/allplace/logic.png`}
                  />
                </div>
                <div className={style.introduce_on_premise_feature_contents}>
                  <div className={style.introduce_on_premise_feature_label}>
                    {t("landing.opF3T")}
                  </div>
                  <div className={style.introduce_on_premise_feature_text}>
                    {t("landing.opF3D")}
                  </div>
                </div>
              </div>
            </div>
            <div
              className={style.contact_list}
              style={!isMobile && !isTablet ? null : { padding: "12px 22px 0" }}
            >
              <div className={style.contact_item}>
                <div className={style.contact_item_title}>
                  {t("landing.buildContact")}
                </div>
              </div>
              <div className={style.contact_item}>
                <div className={style.contact_item_icon_wrap}>
                  <img
                    alt=""
                    src={
                      !isMobile && !isTablet
                        ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/tel.png`
                        : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/tel_m.png`
                    }
                  />
                </div>
                <div className={style.contact_item_text}>
                  <a href={phoneHref}>{phoneDisplay}</a>
                </div>
              </div>
              {!isMobile && !isTablet ? <span /> : null}
              <div className={style.contact_item}>
                <div className={style.contact_item_icon_wrap}>
                  <img
                    alt=""
                    src={
                      !isMobile && !isTablet
                        ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/mail.png`
                        : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/mail_m.png`
                    }
                  />
                </div>
                <div className={style.contact_item_text}>
                  support@riv-tech.co.kr
                </div>
              </div>
            </div>
          </div>

          <div ref={contactRef} style={{ padding: "40px 0" }} />
          <div
            // ref={contactRef}
            className={style.contact_area}
            style={{
              backgroundImage:
                !isMobile && !isTablet
                  ? "url('" +
                    process.env.REACT_APP_CLIENT_URL +
                    "img/solution/allplace/contact_bg.png')"
                  : "url('" +
                    process.env.REACT_APP_CLIENT_URL +
                    "img/solution/allplace/contact_bg_m.png')",
            }}
          >
            <div className={style.contact_contents}>
              <div
                className={style.contact_title}
                style={{ whiteSpace: "pre-line" }}
              >
                {isMobile ? (
                  <Trans
                    i18nKey="landing.ctaTitleM"
                    components={{ 1: <span /> }}
                  />
                ) : (
                  <Trans
                    i18nKey="landing.ctaTitle"
                    components={{ 1: <span /> }}
                  />
                )}
              </div>
              <div
                className={style.contact_text}
                style={{ whiteSpace: "pre-line" }}
              >
                {isMobile ? (
                  <Trans
                    i18nKey="landing.ctaBodyM"
                    components={{ 1: <span />, 2: <span /> }}
                  />
                ) : (
                  <Trans
                    i18nKey="landing.ctaBody"
                    components={{ 1: <span />, 2: <span /> }}
                  />
                )}
              </div>
            </div>
            <div className={style.contact_list}>
              <div className={style.contact_item}>
                <div className={style.contact_item_icon_wrap}>
                  <img
                    alt=""
                    src={
                      !isMobile && !isTablet
                        ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/tel.png`
                        : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/tel_m.png`
                    }
                  />
                </div>
                <div className={style.contact_item_text}>{phoneDisplay}</div>
              </div>
              {!isMobile && !isTablet ? <span /> : null}
              <div className={style.contact_item}>
                <div className={style.contact_item_icon_wrap}>
                  <img
                    alt=""
                    src={
                      !isMobile && !isTablet
                        ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/mail.png`
                        : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/mail_m.png`
                    }
                  />
                </div>
                <div className={style.contact_item_text}>
                  support@riv-tech.co.kr
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Platform;
